module.exports = __webpack_public_path__ + "static/img/ios2.0ebd6b6f.jpg";